import styled from 'styled-components';

export const CardHeaderContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  background-color: #f6f6f6;
  gap: 4px;
  padding: 4px;
  border-radius: 5px;
`;

export const Row = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  width: 100%;
`;

export const FirstRow = styled(Row)`
  gap: 12px !important;
  span {
    font-size: 16px;
    font-weight: 700;
  }

  svg {
    font-size: 24px;
  }
`;

export const SecondRow = styled(Row)`
  flex-wrap: wrap;
  justify-content: space-between;

  span {
    font-size: 12px;
    font-weight: 400;
  }
`;

export const ColorBorder = styled.div`
  display: flex;
  padding: 2px 8px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  border-radius: 8px;
  background: var(--Takeat-Colors-Neutrals-Grey-02, #7a7a7a);

  span {
    color: var(--Takeat-Colors-Neutrals-Grey-05, #f6f6f6);
    /* Label/Label Large/Semibold | 600 */
    font-family: Poppins;
    font-size: 14px;
    font-style: normal;
    font-weight: 600;
    line-height: 20px; /* 142.857% */
    letter-spacing: 0.1px;
  }
`;

export const TextWithdrawal = styled.span`
  color: var(--Takeat-Colors-Neutrals-Black-01, #222);
  /* Label/Label Large/Semibold | 600 */
  font-family: Poppins;
  font-size: 14px !important;
  font-style: normal;
  font-weight: 600;
  line-height: 20px; /* 142.857% */
  letter-spacing: 0.1px;
`;

export const IfoodTurboBadge = styled.span`
  display: flex;
  padding: 2px 8px;
  justify-content: center;
  align-items: center;
  gap: 4px;
  align-self: stretch;
  border-radius: 100px;
  background: rgba(234, 29, 44, 0.15);

  span {
    color: var(--Takeat-Colors-Neutrals-Grey-01, #545454);
    text-align: right;
    font-family: Poppins;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 20px; /* 142.857% */
    letter-spacing: 0.1px;
  }
`